export default __webpack_public_path__ + "static/media/Main.59ef95a8.png";